module.exports = __webpack_public_path__ + "static/media/standard_menu_option.5a0b8e1a.svg";